import { IconProps } from './types';

export function TrendingUp({ size, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 6H21V12H20V7.70711L13.3536 14.3536C13.1583 14.5488 12.8417 14.5488 12.6464 14.3536L9 10.7071L2.85355 16.8536L2.14645 16.1464L8.64645 9.64645C8.84171 9.45118 9.15829 9.45118 9.35355 9.64645L13 13.2929L19.2929 7H15V6Z"
        fill="currentColor"
      />
    </svg>
  );
}
